import { DoorOpen, PackageCheck, PackagePlus, ShieldCheck, ShieldOff, LayoutPanelTop, FileText } from "lucide-react";

export const BITACORA_CONFIG = {
  registro_diario: {
    tipo: "registro_diario",
    label: "Registro Diario de Entradas y Salidas",
    short: "Reg. Diario",
    icon: FileText,
    accent: "navy",
    description: "Transporte de carga y contenedores (Formato Auditoría).",
    fields: [
      { name: "contenedor", label: "Contenedor (C) / CAJA (CA)", type: "text", required: true },
      { name: "compania", label: "Compañía Transportista", type: "text" },
      { name: "tractor", label: "No. de Tractor", type: "text" },
      { name: "placas", label: "No. Placas", type: "text" },
      { name: "chofer", label: "Nombre del Chofer", type: "text" },
      { name: "id_tipo", label: "Tipo de Identificación", type: "text" },
      { name: "sello_seguridad", label: "No. Sello / Candado Alta Seguridad", type: "text" },
      { name: "hora_llegada", label: "Hora de Llegada", type: "time" },
      { name: "firma_llegada", label: "Firma de Llegada", type: "text" },
      { name: "cortina", label: "No. de Cortina", type: "text" },
      { name: "hora_salida", label: "Hora de Salida", type: "time" },
      { name: "procedencia", label: "Procedencia (Ciudad/Puerto)", type: "text" },
      { name: "destino", label: "Destino", type: "text" },
    ],
    columns: ["contenedor", "placas", "chofer", "hora_llegada", "hora_salida"],
  },
  control_cortinas: {
    tipo: "control_cortinas",
    label: "Control de Apertura y Cierre de Cortinas",
    short: "Cortinas",
    icon: LayoutPanelTop,
    accent: "navy",
    description: "Seguimiento de tiempos en andenes (Formato Auditoría).",
    fields: [
      { name: "numero_cortina", label: "Cortina No. / No. DOCK", type: "text", required: true },
      { name: "hora_apertura", label: "Hora de Apertura", type: "time" },
      { name: "area", label: "Área (Embarques / Recibos)", type: "text" },
      { name: "cantidad", label: "No. Cajas / Pallets", type: "text" },
      { name: "nombre_chofer", label: "Nombre del Chofer", type: "text" },
      { name: "compania", label: "Compañía Transportista", type: "text" },
      { name: "tipo_camion", label: "Tipo de Camión", type: "text" },
      { name: "numero_sello", label: "No. Sello", type: "text" },
      { name: "hora_cierre", label: "Hora de Cierre", type: "time" },
      { name: "nombre_seguridad", label: "Nombre Seguridad", type: "text" },
      { name: "destino_procedencia", label: "Destino / Procedencia", type: "text" },
    ],
    columns: ["numero_cortina", "area", "nombre_chofer", "hora_apertura", "hora_cierre"],
  },
  embarque: {
    tipo: "embarque",
    label: "Bitácora de Embarques",
    short: "Embarques",
    icon: PackageCheck,
    accent: "navy",
    description: "Registro de entradas y salidas de carga (Embarque).",
    fields: [
      { name: "contenedor", label: "Contenedor (C) / CAJA (CA)", type: "text", required: true },
      { name: "compania", label: "Compañía Transportista", type: "text" },
      { name: "tractor", label: "No. de Tractor", type: "text" },
      { name: "placas", label: "No. Placas", type: "text" },
      { name: "chofer", label: "Nombre del Chofer", type: "text" },
      { name: "sello_seguridad", label: "No. Sello Alta Seguridad", type: "text" },
      { name: "hora_llegada", label: "Hora de Llegada", type: "time" },
      { name: "cortina", label: "No. de Cortina", type: "text" },
      { name: "hora_salida", label: "Hora de Salida", type: "time" },
      { name: "destino", label: "Destino", type: "text" },
    ],
    columns: ["contenedor", "placas", "chofer", "hora_llegada", "hora_salida"],
  },
  recibo: {
    tipo: "recibo",
    label: "Bitácora de Recibos",
    short: "Recibos",
    icon: PackagePlus,
    accent: "navy",
    description: "Registro de entradas y salidas de carga (Recibo).",
    fields: [
      { name: "contenedor", label: "Contenedor (C) / CAJA (CA)", type: "text", required: true },
      { name: "compania", label: "Compañía Transportista", type: "text" },
      { name: "tractor", label: "No. de Tractor", type: "text" },
      { name: "placas", label: "No. Placas", type: "text" },
      { name: "chofer", label: "Nombre del Chofer", type: "text" },
      { name: "sello_seguridad", label: "No. Sello Alta Seguridad", type: "text" },
      { name: "hora_llegada", label: "Hora de Llegada", type: "time" },
      { name: "cortina", label: "No. de Cortina", type: "text" },
      { name: "hora_salida", label: "Hora de Salida", type: "time" },
      { name: "procedencia", label: "Procedencia", type: "text" },
    ],
    columns: ["contenedor", "placas", "chofer", "hora_llegada", "hora_salida"],
  },
  visita: {
    tipo: "visita",
    label: "Bitácora de Visitas",
    short: "Visitas",
    icon: DoorOpen,
    accent: "navy",
    description: "Registro de entrada y salida de visitantes.",
    fields: [
      { name: "nombre_visitante", label: "Nombre del visitante", type: "text", required: true },
      { name: "empresa", label: "Empresa / Procedencia", type: "text" },
      { name: "motivo", label: "Motivo de la visita", type: "text" },
      { name: "persona_visitada", label: "Persona / Área visitada", type: "text" },
      { name: "identificacion", label: "Identificación presentada", type: "text" },
      { name: "hora_entrada", label: "Hora de entrada", type: "time" },
      { name: "hora_salida", label: "Hora de salida", type: "time" },
      { name: "observaciones", label: "Observaciones", type: "textarea" },
    ],
    columns: ["nombre_visitante", "empresa", "motivo"],
  },
  sellos_retirados: {
    tipo: "sellos_retirados",
    label: "Registro de Sellos Retirados",
    short: "Sellos Retirados",
    icon: ShieldOff,
    accent: "critical",
    description: "Control de sellos que son removidos.",
    fields: [
      { name: "hora", label: "Hora", type: "time", required: true },
      { name: "linea", label: "Línea", type: "text" },
      { name: "cortina", label: "Cortina", type: "text" },
      { name: "numero_sello", label: "Num. Sello", type: "text", required: true },
      { name: "nombre_guardia", label: "Nombre de Guardia", type: "text" },
      { name: "observaciones", label: "Observaciones / Firma", type: "textarea" },
    ],
    columns: ["numero_sello", "linea", "cortina", "nombre_guardia"],
  },
  sellos_colocados: {
    tipo: "sellos_colocados",
    label: "Bitácora de Sellos Colocados",
    short: "Sellos Colocados",
    icon: ShieldCheck,
    accent: "success",
    description: "Registro de sellos de seguridad colocados en salida.",
    fields: [
      { name: "numero_sello", label: "Número de sello", type: "text", required: true },
      { name: "tipo_sello", label: "Tipo de sello", type: "text" },
      { name: "placas", label: "Placas de unidad", type: "text" },
      { name: "numero_caja", label: "Número de caja", type: "text" },
      { name: "colocado_por", label: "Colocado por", type: "text" },
      { name: "destino", label: "Destino", type: "text" },
      { name: "observaciones", label: "Observaciones", type: "textarea" },
    ],
    columns: ["numero_sello", "placas", "colocado_por"],
  },
};

export const BITACORA_TYPES = Object.values(BITACORA_CONFIG);
